import CONFIG from '../config/config';
import { CatalogItem } from '../api/CataloguesAPI';
import { isVideoFile } from './fileUtils';

export const CATALOG_SAVES_STORAGE_PREFIX = 'eateliers-catalog-saves-';

export const catalogSavesStorageKey = (catalogUuid: string) =>
  `${CATALOG_SAVES_STORAGE_PREFIX}${catalogUuid}`;

export const catalogShareSegment = (catalog: { slug?: string | null; uuid?: string | null }): string => {
  const slug = catalog.slug?.trim();
  if (slug) {
    return slug;
  }
  return catalog.uuid || '';
};

export const catalogSharePath = (catalog: { slug?: string | null; uuid?: string | null }): string =>
  `/catalogues/${catalogShareSegment(catalog)}`;

export const catalogBookingUrl = (bookingLink: string): string =>
  `${window.location.origin}/bookings/${bookingLink}?source=catalog`;

export const catalogShowsBookCta = (catalog: {
  showBookAppointment?: boolean;
  bookingLink?: string;
}): boolean => Boolean(catalog.showBookAppointment && catalog.bookingLink?.trim());

export const formatCatalogPrice = (price?: number, currency?: string): string | null => {
  if (price == null || Number(price) === 0) {
    return null;
  }
  const symbol =
    (currency && CONFIG.SUPPORTED_CURRENCIES_SYMBOLS[currency as keyof typeof CONFIG.SUPPORTED_CURRENCIES_SYMBOLS])
    || currency
    || '';
  return `${symbol}${Number(price).toLocaleString()}`;
};

const HTTP_URL = /^https?:\/\//i;
const VARIANT_SUFFIX = /-(thumbnail|medium)(\.[^./?#]+)?$/i;

const catalogImageParts = (url: string): { base: string; extension: string } | null => {
  const path = url.split('?')[0];
  const lastDot = path.lastIndexOf('.');
  const lastSlash = Math.max(path.lastIndexOf('/'), path.lastIndexOf('\\'));
  if (lastDot <= lastSlash) {
    return null;
  }
  return { base: path.slice(0, lastDot), extension: path.slice(lastDot) };
};

const canBuildCatalogImageVariants = (url?: string): url is string => {
  if (!url) {
    return false;
  }
  return HTTP_URL.test(url) && !isVideoFile(url) && !VARIANT_SUFFIX.test(url.split('?')[0]);
};

export const catalogImageSrcSet = (url?: string): string => {
  if (!canBuildCatalogImageVariants(url)) {
    return '';
  }
  const parts = catalogImageParts(url);
  if (!parts) {
    return '';
  }
  return `${parts.base}-thumbnail${parts.extension} 480w, ${parts.base}-medium${parts.extension} 800w`;
};

export const catalogImageThumbnail = (url?: string): string => {
  if (!url || !canBuildCatalogImageVariants(url)) {
    return url || '';
  }
  const parts = catalogImageParts(url);
  if (!parts) {
    return url;
  }
  return `${parts.base}-thumbnail${parts.extension}`;
};

export const catalogHeroMedia = (items: CatalogItem[] = []): string[] => {
  const urls: string[] = [];
  for (const item of items) {
    const first = item.media?.find((url) => url && !isVideoFile(url));
    if (first) {
      urls.push(first);
    }
    if (urls.length >= 3) {
      break;
    }
  }
  return urls;
};
